import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { PageSizeService } from "@shared/services/page-size.service";
import {
  ColDef,
  CsvExportParams,
  type DomLayoutType,
  ExcelExportParams,
  ExcelStyle,
  GetRowIdFunc,
  IsFullWidthRowParams,
  RowClassRules,
  RowGroupingDisplayType,
  type RowSelectionOptions,
  StatusPanelDef
} from "ag-grid-community";
import { GridOptions, RowHeightParams } from "ag-grid-enterprise";

@Component({
  selector: 'app-base-list-grid',
  standalone: true,
  template: '',
})
export class BaseListGridComponent {
  pageSizeService = inject(PageSizeService);

  @Input({ required: true }) colDefs: ColDef[] = [];
  @Input() getRowHeight: ((params: RowHeightParams) => number | undefined | null) | undefined;
  @Input() rowClassRules: RowClassRules<unknown> | undefined;
  @Input() detailRowAutoHeight: boolean | undefined = true;
  @Input() gridOptions: GridOptions | undefined;
  @Input() groupDisplayType: RowGroupingDisplayType = 'singleColumn';
  @Input() statusBar: { statusPanels: StatusPanelDef[] } | undefined;
  @Input() suppressCellFocus = true;
  @Input() suppressRowClickSelection = true;
  @Input() pagination = true;
  @Input() paginationPageSizeSelector = true;
  @Input() suppressPaginationPanel = true;
  @Input() suppressScrollOnNewData = true;
  @Input() paginationPageSize = 20;
  @Input() pageSizeList: number[] = [20, 50, 100, 250];
  @Input() getRowId: GetRowIdFunc<unknown> | undefined;
  @Input() detailCellRenderer: unknown | undefined;
  @Input() detailCellRendererParams: unknown | undefined;
  @Input() defaultExcelExportParams: ExcelExportParams | undefined;
  @Input() defaultCsvExportParams: CsvExportParams | undefined;
  @Input() excelStyles: ExcelStyle[] = [];
  @Input() storageKey: string | undefined;
  @Input() isFullWidthRow: ((params: IsFullWidthRowParams<unknown>) => boolean) | undefined;
  @Input() fullWidthCellRenderer: any | undefined;
  @Input() suppressContextMenu: boolean | null = true;
  @Input() suppressMenuHide: boolean | null = false;
  @Input() masterDetail = true;
  @Input() quickFilterText = '';
  @Input() headerHeight = 46;
  @Input() rowSelection: RowSelectionOptions<any> | 'single' | 'multiple' | undefined = {
    mode: 'multiRow',
    headerCheckbox: true,
    groupSelects: 'self',
    selectAll: 'filtered',
    enableClickSelection: false,
    checkboxes: true,
    checkboxLocation: 'selectionColumn',
    masterSelects: 'self'
  };

  @Output() selectAll = new EventEmitter<boolean>();
  @Output() gridReady = new EventEmitter();
  @Output() select = new EventEmitter();
  @Output() sortChanged = new EventEmitter<unknown>();

  readonly themeClass = 'ag-theme-quartz';
  readonly domLayout: DomLayoutType = 'autoHeight';
  readonly enableAdvancedFilter = false;
  readonly icons = { filter: ' ' };
  readonly floatingFiltersHeight = 0;

  static readonly noCheckboxesRowSelection: RowSelectionOptions<any> = {
    mode: 'singleRow',
    checkboxes: false,
    enableClickSelection: false,
    checkboxLocation: 'selectionColumn',
    masterSelects: 'self'
  };
}
